<template>
  <el-dialog
    :visible="visible"
    width="30%"
    @close="cancel"
    destroy-on-close
    title="退款"
    custom-class="customModal">
    <AppForm
      v-if="visible"
      ref="form"
      formStyle="default"
      :fields="formFields"
      :rules="rules"
      :defaultValues="defaultValues"
      @cancel="cancel"
      @submit="submit"
      />
  </el-dialog>
</template>

<script>
import { OrderService } from '../../../service/order.service';
import AppForm from '../../..//components/form/form.component.vue';
//  0仅退款 1部分退货退款 2全部退货退款
// const refundType = [
//   { label: '仅退款', value: 0 },
//   { label: '部分退货退款', value: 1 },
//   { label: '全部退货退款', value: 2 },
// ]
  export default {
    name: 'delivery',
    components: { AppForm },
    data() {
      return {
        visible: false,
        openType: '',
        defaultValues: {},
        rules: {
          user_return_reason: [{ required: true, message: '请填写原因'}],
          // refund_type: [{ required: true, message: '请选择退货退款类型'}],
        },
        formFields: [
          // { type: 'select', key: 'refund_type', label: '退货退款类型', span: 24, options: refundType },
          { type: 'input', key: 'user_return_reason', label: '退款原因', span: 24 },
        ],
        orderData: {},
        shipData: [],
      }
    },
    async created() {
      // const { data } = await OrderService.shippList({ page: 1, rows: 99999 });
      // this.shipData = data;
      // this.formFields[0].options = data;
      // data.forEach(item => {
      //   item.label = item.shipping_name;
      //   item.value = item.shipping_id;
      // });
      // this.formFields = [...this.formFields]
    },
    methods: {
      open(data) {
        this.orderData = data;
        this.visible = true;
      },
      cancel() {
        this.visible = false;
        this.defaultValues = {};
      },
      async submit(data) {
        // const shipping_name = (this.shipData.find(item => item.value === data.shipping_code) || {}).shipping_name;
        await OrderService.orderRefundCargo({...data, order_sn: this.orderData.order_sn, refund_type: 0})
        this.cancel();
        this.$emit('success');
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>